import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

type EmailChange = {
    email: string;
    password: string;
};

const profileApi = createApi({
    reducerPath: 'profile',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        toggleDarkMode: builder.mutation<void, void>({
            query: () => ({
                url: '/profile/toggle-dark-mode',
                method: 'POST',
            }),
        }),
        changeEmail: builder.mutation<void, EmailChange>({
            query: (payload) => ({
                method: 'POST',
                url: `/profile/update-email`,
                body: payload,
            }),
        }),
    }),
});

export default profileApi;

export const { useToggleDarkModeMutation, useChangeEmailMutation } = profileApi;
